import React from 'react';
import {Helmet} from "react-helmet";
import API from "../../api";
import {withSnackbar} from "notistack";
import '../../assets/css/errors.css';
import "../../assets/css/notification.css";
import "../../assets/css/input.css";
import {instanceOf} from "prop-types";
import {Cookies, withCookies} from "react-cookie";
import 'react-phone-number-input/style.css'
import {hideAlertAfterDelay} from "../../helper";

const api = new API();

class RESET extends React.Component {

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            resetData :{
                password: "",
                confirm_password : ""
            },
            email : this.props.match.params.email,
            errorAlert: false,
            successAlert : false,
            res_message : null,
            errors: {},
            touched: this.getInitialTouchedState(),
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.alertBox = React.createRef();
    }

    componentDidMount() {
        if(this.props.cookies.get('token') && this.props.cookies.get('token') !== undefined && this.props.cookies.get('token') !== ""){
            this.props.history.push('/');
        }
        if(this.state.email === null){
            this.setState({email : this.props.match.params.email })
        }
        if (this.props.cookies.get('toggle') && this.props.cookies.get('toggle') !== undefined && this.props.cookies.get('toggle') === "toggled"){
            this.props.cookies.set('toggle', "");
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.match.params.email.toLowerCase() !== this.props.match.params.email.toLowerCase()  ) {
            this.setState({email: this.props.match.params.email});
        }
        if (this.props.cookies.get('toggle') && this.props.cookies.get('toggle') !== undefined && this.props.cookies.get('toggle') === "toggled"){
            this.props.cookies.set('toggle', "");
        }
    }

    getResetFieldNames() {
        return ["password", "confirm_password"];
    }

    getInitialTouchedState() {
        return this.getResetFieldNames().reduce((touched, name) => {
            touched[name] = false;
            return touched;
        }, {});
    }

    getAllTouchedState() {
        return this.getResetFieldNames().reduce((touched, name) => {
            touched[name] = true;
            return touched;
        }, {});
    }

    getFieldValidationError(name, value, resetData = this.state.resetData) {
        if (name === "password") {
            if (!value) {
                return "Enter new password";
            }

            if (value.length < 8) {
                return "Password must be at least 8 characters";
            }

            if (/\s/.test(value)) {
                return "Password cannot contain spaces";
            }
        }

        if (name === "confirm_password") {
            if (!value) {
                return "Enter confirm password";
            }

            if (value !== resetData.password) {
                return "Passwords do not match";
            }
        }

        return "";
    }

    getFormValidationErrors(resetData = this.state.resetData) {
        const errors = {};

        this.getResetFieldNames().forEach((name) => {
            const error = this.getFieldValidationError(name, resetData[name], resetData);

            if (error) {
                errors[name] = error;
            }
        });

        return errors;
    }

    getUpdatedErrors(resetData, errors = this.state.errors) {
        const updatedErrors = {...errors};

        this.getResetFieldNames().forEach((name) => {
            if (!this.state.touched[name]) {
                return;
            }

            const fieldError = this.getFieldValidationError(name, resetData[name], resetData);

            if (fieldError) {
                updatedErrors[name] = fieldError;
            } else {
                delete updatedErrors[name];
            }
        });

        return updatedErrors;
    }

    showValidationErrors(errors) {
        this.setState({
            errors,
            errorAlert: false,
            touched: this.getAllTouchedState(),
        });
    }

    showTimedErrorAlert(message) {
        this.setState({
            res_message: message,
            errorAlert: true
        });

        if (this.alertTimeout) {
            clearTimeout(this.alertTimeout);
        }

        this.alertTimeout = hideAlertAfterDelay(() => {
            this.setState({ errorAlert: null });
        });
    }

    handleChange(event) {
        const {name, value} = event.target;
        const resetData = {...this.state.resetData, [name]: value};

        this.setState({
            resetData,
            res_message : null,
            errorAlert : false,
            // Keep first typing quiet; touched fields validate on change so visible errors clear immediately.
            errors: this.getUpdatedErrors(resetData),
        });
    }

    handleBlur(event) {
        const {name} = event.target;
        const touched = {
            ...this.state.touched,
            [name]: true,
        };
        const errors = {...this.state.errors};
        const fieldError = this.getFieldValidationError(name, this.state.resetData[name]);

        if (fieldError) {
            errors[name] = fieldError;
        } else {
            delete errors[name];
        }

        this.setState({touched, errors});
    }

    handleSubmit(event) {

        event.preventDefault();

        const errors = this.getFormValidationErrors();

        if (Object.keys(errors).length > 0) {
            this.showValidationErrors(errors);
            return false;
        }

        api.changePassword({key : this.state.email , password : this.state.resetData.password , re_password : this.state.resetData.confirm_password }).then(success => {
            if (success.data.status == "400") {
                this.showTimedErrorAlert(success.data.message);
                return false;
            }else{
                this.props.enqueueSnackbar(success.data.message, {
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'center',
                    },
                    variant: 'success',
                });
                this.setState({
                    email: '',
                    resetData: { password: '', confirm_password: ''},
                    errors: {},
                    touched: this.getInitialTouchedState(),
                });
                this.props.history.push("/login");
            }
        }).catch(error => {
            this.showTimedErrorAlert(error?.response?.data?.message || "Something went wrong. Please try again.");
        });
    }

    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>
                        Forgot Password - Farmer&#039;s Fresh Meat: Houston Meat Market
                        &amp; Butcher Shop
                    </title>
                </Helmet>

                <div className="container">
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-9 col-lg-7 col-xl-6 mx-auto">
                            <div className="bg-white border-1 main-section px-5 py-5">
                                <div className="signin-info text-center mt-0">
                                    <h1 className="mb-2">Password Reset</h1>
                                    <p className="font-weight-normal mb-2">Create new password for your account.</p>
                            </div>

                            {this.state.successAlert ? (
                                <div className="col-12">
                                    <div ref={this.alertBox}
                                         role="alert"
                                         className="sc-1wz9i2x-0 fooVeKSuccess align-items-start mt-1"
                                    >
                                        <svg viewBox="0 0 512 512" className="text-success w-16 mr-2">
                                            <path d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM371.8 211.8C382.7 200.9 382.7 183.1 371.8 172.2C360.9 161.3 343.1 161.3 332.2 172.2L224 280.4L179.8 236.2C168.9 225.3 151.1 225.3 140.2 236.2C129.3 247.1 129.3 264.9 140.2 275.8L204.2 339.8C215.1 350.7 232.9 350.7 243.8 339.8L371.8 211.8z"/>
                                        </svg>
                                        <div className="text-message">
                                            <h6>Password reset successfully</h6>
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                            {this.state.errorAlert ? (
                                <div className="col-12">
                                    <div ref={this.alertBox}
                                         role="alert"
                                         className="sc-1wz9i2x-0 fooVeK align-items-start mt-1"
                                    >
                                        <svg
                                            width="1792"
                                            height="1792"
                                            viewBox="0 0 1792 1792"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                            className="sc-1t1e23j-0 bbiirI"
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M1024 1375v-190q0-14-9.5-23.5T992 1152H800q-13 0-22.5 9.5T768 1185v190q0 14 9.5 23.5t22.5 9.5h192q13 0 22.5-9.5t9.5-23.5zm-2-374l18-459q0-12-10-19-13-11-24-11H786q-11 0-24 11-10 7-10 21l17 457q0 10 10 16.5t24 6.5h185q14 0 23.5-6.5t10.5-16.5zm-14-934l768 1408q35 63-2 126-17 29-46.5 46t-63.5 17H128q-34 0-63.5-17T18 1601q-37-63-2-126L784 67q17-31 47-49t65-18 65 18 47 49z"
                                            ></path>
                                        </svg>
                                        <div className="text-message">
                                            <h6>{this.state.res_message}</h6>
                                        </div>
                                    </div>
                                </div>
                            ) : null}


                                <form>
                                    <div className="row">
                                        <div className="form-group col-12 mb-4">
                                            <input
                                                type="password"
                                                className={
                                                    "form-control info-control " +
                                                    (this.state.errors.password ? "invalid" : "")
                                                }
                                                id="password"
                                                name="password"
                                                placeholder="New Password*"
                                                value={this.state.resetData.password}
                                                onChange={this.handleChange}
                                                onBlur={this.handleBlur}
                                                maxLength="25"
                                            />
                                            <span className="error-text mt-1 mb-1">
                                                {this.state.errors.password}
                                            </span>
                                        </div>
                                        <div className="form-group col-12 mb-4">
                                            <input
                                                type="password"
                                                className={
                                                    "form-control info-control " +
                                                    (this.state.errors.confirm_password ? "invalid" : "")
                                                }
                                                id="confirm_password"
                                                name="confirm_password"
                                                placeholder="Confirm Password*"
                                                value={this.state.resetData.confirm_password}
                                                onChange={this.handleChange}
                                                onBlur={this.handleBlur}
                                                maxLength="25"
                                            />
                                            <span className="error-text mt-1 mb-1">
                                                {this.state.errors.confirm_password}
                                            </span>
                                        </div>
                                        <div
                                            className="update-btn col-12"
                                            onClick={this.handleSubmit}
                                        >
                                            <a
                                                href="#"
                                                className="btn btn-cart w-100"
                                            >
                                                Reset
                                            </a>
                                        </div>
                                    </div>

                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default withCookies(withSnackbar(RESET));
